<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-06-07 17:08:39
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 12:10:34
 * @FilePath: \jyrg-web\src\components\public\VoucherCenter\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="main" v-show="true">
    {{ show }}
    <div id="mask" v-if="show"></div> 
    <!-- <div id="mask" v-show="true"></div>  -->
    <!-- <transition name="el-zoom-in-top"> -->
    <transition name="el-zoom-in-top">
      <div class="map-order">
        <img
          class="close"
          src="../../../assets/image/pc/close.png"
          alt=""
          @click="close"
        />
        <div class="title">宣传活动</div>
        <div class="form">
          <el-form :model="form" :rules="rules" ref="form">
            <div class="layout">
              <el-form-item prop="phone" class="phone">
                <el-input
                  v-model.trim="form.phone"
                  placeholder="请输入手机号"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code" class="code">
                <el-row type="flex" justify="space-between">
                  <el-input
                    v-model.number="form.code"
                    placeholder="请输入验证码"
                  ></el-input>
                  <div
                    v-if="showCode"
                    type="primary"
                    @click.stop="sendVerificationCode"
                    class="button"
                  >
                    发送验证码
                  </div>
                  <div class="button" v-if="!showCode" type="primary" disabled>
                    {{ count }}秒后重发
                  </div>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="msg">
        <button :class="{ 'is-selected': isSelected }" @click="toggleSelection">
                {{ isSelected ? '' : '' }}
        </button>
            我同意
            <a @click="footerSkip(footer.userAgreement)">{{
              footer.userAgreement.title
          }}</a>
            {{ " | " }}
            <a @click="footerSkip(footer.privacyPolicy)">{{
              footer.privacyPolicy.title
            }}</a>
      </div>
 
        <div class="submit" @click="submit"><p>登录</p></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Notify } from "vant";
import { Notification } from "element-ui";
import { getToken } from "@/utils/auth";
import webSite from "../../../api/webSite";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    show: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    // 手机号校验
    let checkPhone = (rule, value, callback) => {
      var reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("手机号码格式不正确"));
      }
    };

    
    return {
      isSelected: false,//选中事件
      showCode: true,
      count: "",
      timer: null,
      form: {
        phone: "",
        code: "",
        phoneNumbers:[],
      },
   
      rules: {
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    footer() {
      return this.$config.footer;
    },

  },
  mounted() {
  },
  methods: {
    ...mapActions({
    Login: "user/Login",           
    LoginShortTime: "user/LoginShortTime" 
  }),


    // 登录
    submit() {
      if (this.isSelected == true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          try {
            let { code: extendCode } = this.$route.query;
            let params = { ...this.form, extendCode }; //注释邀请码
            let res = await this.Login(params);
            let { user_status, status, message: mes } = res.data;
            let type = this.$utils.isClientType() == "pc" ? true : false;
             if(status==1){
             let message = status ? "登录成功" : "登录失败";
             type
              ? Notification({
                  title: message,
                  offset: 50,
                  customClass: "messageIndex",
                  type: status ? "success" : "warning",
                })
              : Notify({ message, background: "#e8cdaa", duration: 2500 });
              if (status) {
                let params = { token: getToken() };
                this.$store.dispatch("user/luckNum", params); // 获取抽奖次数 & 获取邀约人数
                this.$store.dispatch("user/getUserStatus", params); // 获取用户状态
                this.$store.dispatch("user/luckRecordList", params); // 获取中奖记录
                this.close();
              }

             }else{ 
              //这里在请求一下临时验证码看看是否存在 
              this.form.phoneNumbers = [];
              this.form.phoneNumbers.push(this.form.phone)
              const res = await webSite.loadSmsCode( this.form);
              if(res.data!=null){
                if(res.data[0].code==this.form.code){
                      let res = await this.LoginShortTime(params);
                      let { user_status, status, message: mes } = res.data;
                      let message = status ? "登录成功" : "登录失败";
                    type
                      ? Notification({
                          title: message,
                          offset: 50,
                          customClass: "messageIndex",
                          type: status ? "success" : "warning",
                        })
                      : Notify({ message, background: "#e8cdaa", duration: 2500 });
                      if (status) {
                        let params = { token: getToken() };
                        this.$store.dispatch("user/luckNum", params); // 获取抽奖次数 & 获取邀约人数
                        this.$store.dispatch("user/getUserStatus", params); // 获取用户状态
                        this.$store.dispatch("user/luckRecordList", params); // 获取中奖记录
                        this.close();
                      }
                }else{
                  let message ="登录失败！验证码不匹配请联系客服";
                    type
                    ? Notification({
                        title: message,
                        offset: 50,
                        customClass: "messageIndex",
                        type: status ? "success" : "warning",
                      })
                    : Notify({ message, background: "#e8cdaa", duration: 2500 });
                   }

              }else{
                let message ="登录失败！联系客服";
              type
              ? Notification({
                  title: message,
                  offset: 50,
                  customClass: "messageIndex",
                  type: status ? "success" : "warning",
                })
              : Notify({ message, background: "#e8cdaa", duration: 2500 });
              }

             }

            //这里要处理临时验证码登录
            // // user_status 0 老用户 1 新用户
            // // let message = status
            // //   ? user_status
            // //     ? "预约成功，抽奖次数+1"
            // //     : "您已成功预约，不能重复预约"
            // //   : "发送失败，请稍后再试！";
            // let message = status ? "登录成功" : "登录失败";
            // type
            //   ? Notification({
            //       title: message,
            //       offset: 50,
            //       customClass: "messageIndex",
            //       type: status ? "success" : "warning",
            //     })
            //   : Notify({ message, background: "#e8cdaa", duration: 2500 });

            // if (status) {
            //   let params = { token: getToken() };
            //   this.$store.dispatch("user/luckNum", params); // 获取抽奖次数 & 获取邀约人数
            //   this.$store.dispatch("user/getUserStatus", params); // 获取用户状态
            //   this.$store.dispatch("user/luckRecordList", params); // 获取中奖记录
            //   this.close();
            // }
          } catch (error) {
            console.log(error);
          }
        } else {
          return false;
        }
      });
    }else{
      this.$message({
          type: 'error',
          message: "用户协议未同意"
        })
    }
    },

    toggleSelection() {
      this.isSelected = !this.isSelected;
    },
    async footerSkip(item) {
      let { id, title, type } = item;
      this.$router.push({ path: "/detail", query: { id, title, type } });
    },
    // 发送验证码
    sendVerificationCode() {
      this.$refs.form.clearValidate("code");
      this.$refs.form.validateField("phone", (error) => {
        if (!error) {
          let TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.showCode = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.showCode = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);

            this.getCode();
          }
        }
      });
    },

    // 获取验证码
    async getCode() {
      try {
        let { phone } = this.form;
        let res = await this.$api.orderApi.getVerificationCode({
          phone: Number(phone),
        });
        let { message, status, code_status } = res.data;
        let type = this.$utils.isClientType() == "pc" ? true : false;
        let mes = status
          ? "验证码已发送"
          : code_status
          ? "获取验证码次数上限，请稍后再试"
          : message;
        type
          ? Notification({
              title: mes,
              offset: 50,
              customClass: "messageIndex",
              type: "success",
            })
          : Notify({ message: mes, background: "#e8cdaa", duration: 1500 });
      } catch (error) {
        console.log(error);
      }
    },

    // 弹窗关闭
    close() {
      this.$emit("close", false);
    },

    // 高层级message
    messageTip(message, type) {
      this.$message({ message, type, customClass: "messageIndex" });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  #mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 999;
  }
  .main {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;

    .map-order {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 384px;
      height: 284px;
      background: url("~@/assets/image/pc/basemap-orderdialog.png");
      background-size: 100% 100%;
      margin-top: 60%;
      z-index: 9998;
      left: -3%;
      .title {
        text-align: center;
        font-size: 25px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(to bottom, #bb9a60, #884f1d);
        margin-top: 40px;
        margin-bottom: 15px;
      }
      .msg {
         width: 300px;
         font-size: 12px;
         font-weight: bold;
        color:  #502d07;
        text-align: center;
        line-height: 10px;
        margin-top: 1%;
        margin-bottom: 1%;
        a {
          text-decoration: underline;
          cursor: pointer;
          font-size: 12px;
        }
        button {
        padding: inherit;
        background-color: #fbf8f1;
        border:1px solid #fbf8f1;;
        width: 16px;
        height: 14px;
        border-radius: 15%; 
      }
      }
      .is-selected {
        width: 14px;
        height: 16px;
        background: url(../../../assets/image/pc/recharge/check.png) no-repeat !important;
        background-size: 17px 12px !important;
 
    }
      .form {
        width: 260px;
        height: 99px;

        .layout {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100px;
        }
        /deep/ .el-form-item__content {
          line-height: 35px;
        }
        /deep/ .el-input {
          height: 35px;
          color: #000;
          .el-input__inner {
            height: 100%;
            font-size: 15px;
            background-color: #f5eddd;
          }
          .el-input__inner:hover {
            border: 1px solid #b78b63;
          }
          .el-input__inner:focus {
            border: 1px solid #b78b63;
          }
        }
        .phone {
        }
        .code {
          /deep/ .el-input {
            width: 267px;
          }
          .button {
            width: 150px;
            height: 35px;
            line-height: 35px;
            font-size: 15px;
            text-align: center;
            background: url("~@/assets/image/pc/basemap-code.png");
            cursor: pointer;
            color: #000;
            margin-left: 5px;
            border-radius: 5px;
          }
          button:active {
            border: 1px solid #b78b63;
          }
        }

        
      }
      .submit {
        width: 171.5px;
        height: 37.5px;
        background: url("~@/assets/image/pc/basemap-oreder-submit.png");
        background-size: 100% 100%;
        margin-top: 10px;
        text-align: center;
        line-height: 37.5px;
        cursor: pointer;
        p {
          font-size: 25px;
          color: transparent;
          -webkit-background-clip: text;
          background-image: linear-gradient(to bottom, #bb9a60, #884f1d);
        }
      }
      .close {
        position: absolute;
        width: 24px;
        height: 27px;
        top: -10%;
        right: 0%;
        transform-origin: 50% 50%;
        transition: transform 0.5s ease; /* 添加过渡效果，使翻转更平滑 */
      }
    }
  }
}
@media screen and (min-width: 620px) {
  #mask {
    position: absolute;
    top: 0;
    min-width: 1920px;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 9998;
  }
  .main {
    display: flex;
    justify-content: center;
    .map-order {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 768px;
      height: 568px;
      background: url("~@/assets/image/pc/basemap-orderdialog.png");
      background-size: 100% 100%;
      margin-top: 10%;
      z-index: 9998;
      .title {
        text-align: center;
        font-size: 60px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(to bottom, #bb9a60, #884f1d);
        margin-top: 70px;
        margin-bottom: 30px;
      }
      .form {
        width: 521px;
        height: 198px;

        .layout {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 200px;
        }
        /deep/ .el-input {
          height: 70px;
          color: #000;
          .el-input__inner {
            height: 100%;
            font-size: 30px;
            background-color: #f5eddd;
          }
          .el-input__inner:hover {
            border: 1px solid #b78b63;
          }
          .el-input__inner:focus {
            border: 1px solid #b78b63;
          }
        }
        .phone {
        }
        .code {
          /deep/ .el-input {
            width: 267px;
          }
          .button {
            width: 210px;
            height: 70px;
            line-height: 70px;
            text-align: center;
            font-size: 30px;
            background: url("~@/assets/image/pc/basemap-code.png");
            cursor: pointer;
            color: #000;
            border-radius: 5px;
          }
          .button:active {
            border: 1px solid #b78b63;
          }
        }
      }
      .submit {
        width: 343px;
        height: 75px;
        background: url("~@/assets/image/pc/basemap-oreder-submit.png");
        background-size: 100% 100%;
        margin-top: 20px;
        text-align: center;
        line-height: 75px;
        cursor: pointer;
        p {
          font-size: 50px;
          color: transparent;
          -webkit-background-clip: text;
          background-image: linear-gradient(to bottom, #bb9a60, #884f1d);
        }
      }
      .close {
        position: absolute;
        width: 24px;
        height: 27px;
        top: -5%;
        right: -5%;
        transform-origin: 50% 50%;
        transition: transform 0.5s ease; /* 添加过渡效果，使翻转更平滑 */
      }
      .close:hover {
        transform: rotate(180deg); /* 鼠标悬停时顺时针翻转180度 */
      }

      @keyframes close {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(90deg);
        }
      }

      .topup {
        width: 150px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        margin: 10px 0 0 0;
        background-size: 100% 100%;
        color: #eac46c;
        cursor: pointer;
      }
      .agreement {
        position: relative;
        display: flex;
        align-items: center;
        margin: 15px;
        .noimg {
          display: flex;
          align-items: center;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          margin-right: 5px;
          border-radius: 5px;
          img {
            width: 18px;
            height: 12 px;
          }
        }
        .msg {
          font-size: 10px;
          color: #000;
          a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .button {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .message {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 8px;
        color: #000;
        .question {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
      #mask-qrcode {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 1001;
        .qrcode {
          display: flex;
          flex-direction: column;
          position: absolute;
          align-items: center;
          justify-content: space-around;
          top: 50%;
          left: 50%;
          width: 240px;
          height: 240px;
          margin-top: -120px;
          margin-left: -120px;
          border-radius: 4px;
          background-color: #fff;
          span {
            color: #000;
            font-size: 16px;
          }
          img {
            width: 180px;
            height: 180px;
          }
        }
      }
      .text {
        font-size: 8px;
        color: #000;
        margin-right: 5px;
      }
    }
  }
  .msg {
         width: 300px;
         font-size: 20px;
         font-weight: bold;
        color:  #502d07;
        text-align: center;
        line-height: 10px;
        margin-top: 1%;
        margin-bottom: 1%;
        a {
          text-decoration: underline;
          cursor: pointer;
          font-size: 20px;
        }
        button {
        padding: inherit;
        background-color: #fbf8f1;
        border:1px solid #fbf8f1;;
        width: 21px;
        height: 19px;
        border-radius: 15%; 
      }
      }
      .is-selected {
        width: 14px;
        height: 16px;
        background: url(../../../assets/image/pc/recharge/check.png) no-repeat !important;
        background-size: 20px 20px !important;
 
    }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}

</style>
